import { GzPolicyUiSettingsTableWebComponent } from './component/GzPolicyUiSettingsTableWebComponent';

export { GzPolicyUiSettingsTableWebComponent };
